module.exports = __webpack_public_path__ + "img/hershey-choco.cc77c9de.jpg";